import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { useSite } from "../context/SiteContext";
import { GALLERY_PHOTOS, track } from "../lib/site";

export default function About() {
  const { openBooking } = useSite();
  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[3]}
        eyebrow="About Us"
        lines={[<>Rooted in Anand,</>, <em>made for rest.</em>]}
        lede="Madhubhan Resort & Spa is Gujarat's ethno-modern sanctuary — a resort built on the belief that true luxury is time, space and warmth."
      />
      <section className="section-pad intro" data-testid="about-story">
        <Reveal className="section-kicker">Our story</Reveal>
        <div className="intro-copy">
          <Reveal><h2>Hospitality,<br /><em>the Gujarati way.</em></h2></Reveal>
          <Reveal delay={0.12}>
            <p>Set on the Anand–Sojitra Road near Vallabh Vidyanagar, Madhubhan grew from a simple idea: that a guest is family arriving home. Our cottages borrow their spirit from the villages of Gujarat — teak joinery, shaded verandas, gardens that ask you to slow down — while our suites hold every contemporary comfort.</p>
            <p>Today the estate brings together eight distinctive stays, The Sutra Spa, four dining settings and lawns that have hosted generations of celebrations. What has never changed is the welcome.</p>
          </Reveal>
        </div>
        <Reveal className="intro-stats">
          <div><strong>8</strong><span>Distinctive rooms,<br />cottages & suites</span></div>
          <div><strong>4</strong><span>Dining settings<br />across the estate</span></div>
          <div><strong>100s</strong><span>Of weddings &<br />celebrations hosted</span></div>
          <div><strong>1</strong><span>Promise —<br />you'll want to return</span></div>
        </Reveal>
      </section>
      <Marquee />
      <section className="section-pad stay-section" data-testid="about-cta">
        <div className="section-heading">
          <Reveal><div><span className="eyebrow">Visit us</span><h2>The kettle<br /><em>is on.</em></h2></div></Reveal>
          <Reveal delay={0.1}><p>Whether it's a weekend away, a honeymoon or the family's big day — our reservations desk is a call or a message away.</p></Reveal>
        </div>
        <Reveal className="center-row">
          <button className="gold-button" onClick={() => { track("book_now_click", { location: "about_page" }); openBooking({}); }} data-testid="about-book-button">
            Begin your stay <ArrowUpRight size={16} />
          </button>
        </Reveal>
      </section>
    </main>
  );
}
